export default __webpack_public_path__ + "static/CWG22-Workplace-48f431b78284c879d4d0b45a498b2684.jpeg";